import { NetworkState } from '../../constants';

export const NOTIFICATION_DELAYS_MS = {
    [NetworkState.OFFLINE]: 5000,
    [NetworkState.RECONNECTING]: 0,
    [NetworkState.ONLINE]: 1000,
} as const;
